<div class="flex flex-col w-full h-full bg-white overflow-hidden">
  @if (loading) {
    <app-loader></app-loader>
  }

  <div class="flex justify-between items-start p-6 border-b border-gray-200">
    <div class="flex items-center gap-4 min-w-0">
      <div
        class="w-16 h-16 rounded-2xl bg-purple-50 text-purple-700 overflow-hidden flex items-center justify-center shrink-0"
      >
        <span class="text-lg font-semibold">
          {{ salonForm.get("name")?.value?.charAt(0) || "S" }}
        </span>
      </div>

      <div class="flex flex-col min-w-0">
        <span
          class="text-xs text-purple-700 bg-purple-50 px-3 py-1 rounded-full w-fit mb-2"
        >
          Salon Location
        </span>

        <h2 class="text-xl md:text-2xl font-semibold text-gray-900 truncate">
          {{ salonForm.get("name")?.value || modalTitle }}
        </h2>

        <p class="text-sm text-gray-600 truncate">
          {{ salonForm.get("email")?.value || "No contact email entered yet" }}
        </p>
      </div>
    </div>

    <button
      type="button"
      class="w-9 h-9 rounded-full border border-gray-200 bg-white flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-50"
      (click)="onClose()"
    >
      ×
    </button>
  </div>

  <div
    class="grid grid-cols-2 md:grid-cols-4 gap-3 p-6 border-b border-gray-200"
  >
    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Salon Status</span>
      <strong class="text-lg font-semibold text-gray-900">
        {{ isEditMode ? "Existing" : "New" }}
      </strong>
    </div>

    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Business Type</span>
      <strong class="text-lg font-semibold text-gray-900 truncate block">
        {{ readableBusinessType }}
      </strong>
    </div>

    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Staff</span>
      <strong class="text-lg font-semibold text-gray-900">
        {{ salonForm.get("numberOfStaff")?.value || 0 }}
      </strong>
    </div>

    <div class="bg-white border border-gray-200 rounded-lg p-4">
      <span class="block text-xs text-gray-600 pb-2">Images</span>
      <strong class="text-lg font-semibold text-gray-900">
        {{ previewUrls.length || 0 }}
      </strong>
    </div>
  </div>

  <div class="flex gap-2 overflow-x-auto p-4 border-b border-gray-200 bg-white">
    <button
      *ngFor="let tab of tabs"
      type="button"
      class="px-4 py-2 rounded-3xl border text-sm whitespace-nowrap"
      [class.bg-gray-950]="activeTab === tab.key"
      [class.text-white]="activeTab === tab.key"
      [class.border-gray-950]="activeTab === tab.key"
      [class.bg-white]="activeTab !== tab.key"
      [class.text-gray-700]="activeTab !== tab.key"
      [class.border-gray-200]="activeTab !== tab.key"
      (click)="activeTab = tab.key"
    >
      {{ tab.label }}
    </button>
  </div>

  <form
    class="flex-1 overflow-y-auto p-6 flex flex-col gap-6"
    [formGroup]="salonForm"
    (ngSubmit)="onSubmit()"
  >
    @if (activeTab === "overview") {
      <section class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            Basic Information
          </h3>

          <div class="grid gap-4">
            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Salon Name *
              </span>

              <input
                class="input"
                formControlName="name"
                placeholder="Enter salon name"
                [class.!border-red-500]="!checkValidField('name')"
              />

              <span class="error" *ngIf="!checkValidField('name')">
                Salon name is required
              </span>
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Business Type *
              </span>

              <select
                class="input"
                formControlName="businessType"
                [class.!border-red-500]="!checkValidField('businessType')"
              >
                <option value="">Select your business type</option>
                <option value="hair_salon">Hair Salon</option>
                <option value="nail_salon">Nail Salon</option>
                <option value="beauty_salon">Beauty Salon</option>
                <option value="body_wellness">Body & Wellness</option>
                <option value="hair_removal">Hair Removal</option>
                <option value="permanent_beauty">Permanent Beauty</option>
                <option value="multi_service">Multi Service</option>
              </select>

              <span class="error" *ngIf="!checkValidField('businessType')">
                Business type is required
              </span>
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Years in Business *
              </span>

              <input
                type="number"
                class="input"
                formControlName="yearsInBusiness"
                placeholder="Enter years"
                [class.!border-red-500]="!checkValidField('yearsInBusiness')"
              />

              <span class="error" *ngIf="!checkValidField('yearsInBusiness')">
                Years in business is required
              </span>
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Number of Staff *
              </span>

              <input
                type="number"
                class="input"
                formControlName="numberOfStaff"
                placeholder="Enter number"
                [class.!border-red-500]="!checkValidField('numberOfStaff')"
              />

              <span class="error" *ngIf="!checkValidField('numberOfStaff')">
                Number of staff is required
              </span>
            </label>
          </div>
        </div>

        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            Owner Details
          </h3>

          <div class="grid gap-4">
            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Owner First Name *
              </span>

              <input
                class="input"
                formControlName="ownerFirstName"
                placeholder="Enter first name"
                [class.!border-red-500]="!checkValidField('ownerFirstName')"
              />

              <span class="error" *ngIf="!checkValidField('ownerFirstName')">
                Owner first name is required
              </span>
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Owner Last Name *
              </span>

              <input
                class="input"
                formControlName="ownerLastName"
                placeholder="Enter last name"
                [class.!border-red-500]="!checkValidField('ownerLastName')"
              />

              <span class="error" *ngIf="!checkValidField('ownerLastName')">
                Owner last name is required
              </span>
            </label>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Description
              </span>

              <textarea
                class="input min-h-[120px]"
                formControlName="description"
                placeholder="Enter salon description"
              ></textarea>
            </label>
          </div>
        </div>
      </section>
    }

    @if (activeTab === "location") {
      <section class="bg-white border border-gray-200 rounded-lg p-5">
        <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
          Address Information
        </h3>

        <app-google-address
          formControlName="address"
          (placeSelected)="onAddressSelected($event)"
          [invalid]="addressInvalid"
        >
        </app-google-address>

        <span class="error" *ngIf="!checkValidField('address')">
          Address is required
        </span>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          <label class="flex flex-col gap-1">
            <span class="text-sm font-medium text-gray-700">Country *</span>

            <select
              class="input"
              formControlName="country"
              [class.!border-red-500]="!checkValidField('country')"
            >
              <option value="">Select country</option>

              <option *ngFor="let c of countries" [value]="c.name">
                {{ c.name }}
              </option>
            </select>

            <span class="error" *ngIf="!checkValidField('country')">
              Country is required
            </span>
          </label>

          <label class="flex flex-col gap-1">
            <span class="text-sm font-medium text-gray-700">
              State/Province *
            </span>

            <input
              class="input"
              formControlName="state"
              placeholder="Enter state"
              [class.!border-red-500]="!checkValidField('state')"
            />

            <span class="error" *ngIf="!checkValidField('state')">
              State/province is required
            </span>
          </label>

          <label class="flex flex-col gap-1">
            <span class="text-sm font-medium text-gray-700">
              Postal Code *
            </span>

            <input
              class="input"
              formControlName="postalCode"
              placeholder="Enter postal code"
              [class.!border-red-500]="!checkValidField('postalCode')"
            />

            <span class="error" *ngIf="!checkValidField('postalCode')">
              Postal code is required
            </span>
          </label>
        </div>

        <label class="flex flex-col gap-1 mt-4">
          <span class="text-sm font-medium text-gray-700">City *</span>

          <input
            class="input"
            formControlName="city"
            placeholder="Enter city"
            [class.!border-red-500]="!checkValidField('city')"
          />

          <span class="error" *ngIf="!checkValidField('city')">
            City is required
          </span>
        </label>
      </section>
    }

    @if (activeTab === "contact") {
      <section class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-white border border-gray-200 rounded-lg p-5">
          <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
            Contact Information
          </h3>

          <div class="grid gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2">
                Mobile Number *
              </label>

              <ngx-intl-tel-input
                class="block w-full"
                [cssClass]="customCssClass"
                [preferredCountries]="preferredCountries"
                [enableAutoCountrySelect]="true"
                [enablePlaceholder]="true"
                [searchCountryFlag]="true"
                [searchCountryField]="[
                  SearchCountryField.Iso2,
                  SearchCountryField.Name
                ]"
                [selectFirstCountry]="false"
                [selectedCountryISO]="CountryISO.UnitedStates"
                [maxLength]="15"
                [phoneValidation]="true"
                [separateDialCode]="separateDialCode"
                [numberFormat]="PhoneNumberFormat.National"
                name="phone"
                formControlName="phone"
              >
              </ngx-intl-tel-input>

              <small *ngIf="validationChecker()" class="text-red-500">
                Invalid Phone Number
              </small>
            </div>

            <label class="flex flex-col gap-1">
              <span class="text-sm font-medium text-gray-700">
                Email Address *
              </span>

              <input
                type="email"
                class="input"
                formControlName="email"
                placeholder="Enter email"
                [class.!border-red-500]="!checkValidField('email')"
              />

              <span class="error" *ngIf="!checkValidField('email')">
                Valid email is required
              </span>
            </label>
          </div>
        </div>
      </section>
    }

    @if (activeTab === "media") {
      <section class="bg-white border border-gray-200 rounded-lg p-5">
        <h3 class="text-sm md:text-lg text-gray-900 font-medium pb-4">
          Salon Photos
        </h3>

        <div
          class="hover:border-purple-300 hover:bg-purple-50 transition-colors cursor-pointer"
          (click)="fileInput.click()"
          (dragover)="handleDragOver($event)"
          (drop)="handleDrop($event)"
        >
          <div
            class="flex flex-col justify-center items-center border border-gray-200 rounded-xl px-4 py-5 text-center gap-3"
          >
            <span class="text-3xl text-gray-400">📁</span>

            <div class="text-xs">
              <span class="text-purple-brand">Click to upload</span>
              <span> or drag and drop</span>

              <p class="text-xs text-gray-400 pt-1">
                SVG, PNG, JPG or GIF max. 5MB. Up to 5 images.
              </p>
            </div>
          </div>

          <input
            #fileInput
            type="file"
            multiple
            accept="image/*"
            (change)="handleFileSelect($event)"
            class="hidden"
          />
        </div>

        <div
          *ngIf="previewUrls.length > 0"
          class="mt-4 grid grid-cols-2 md:grid-cols-3 gap-3 max-h-[360px] overflow-y-auto"
        >
          <div
            *ngFor="let url of previewUrls; let i = index"
            class="relative group"
          >
            <img
              [src]="url"
              alt="Preview"
              class="w-full h-[160px] object-cover rounded-lg border border-gray-200"
            />

            <button
              type="button"
              (click)="removeImage(i)"
              class="absolute w-6 h-6 flex justify-center items-center top-2 right-2 bg-black text-white rounded-full text-xs opacity-0 group-hover:opacity-100 transition-opacity"
            >
              ✕
            </button>
          </div>
        </div>
      </section>
    }

    <div class="sticky bottom-0 bg-white pt-4 border-t border-gray-200">
      <div class="ml-auto flex justify-end gap-3">
        <button
          type="button"
          class="px-6 py-2 shadow rounded-3xl bg-white text-gray-900 border border-gray-200"
          (click)="onClose()"
        >
          Cancel
        </button>

        <button
          type="submit"
          class="px-6 py-2 shadow rounded-3xl bg-gray-950 text-white"
        >
          {{ isEditMode ? "Save Changes" : "Create Salon" }}
        </button>
      </div>
    </div>
  </form>
</div>